/** @format */

import Modal from 'react-modal';

Modal.setAppElement('#root');

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    background: 'rgba(102, 103, 171, 1)',
    color: '#fff',
    borderRadius: '10px',
    zIndex: '99999999999999999999999',
  },
};
const ShowImageModal = ({
  modalIsOpen = false,
  image = '',
  classes,
  styles,
  title,
  setModalIsOpen,
}) => {
  return (
    <Modal
      isOpen={modalIsOpen}
      className={classes}
      style={{ ...customStyles, styles }}
      shouldCloseOnOverlayClick={true}
    >
      <div className='d-flex flex-row border-bottom pb-2'>
        <i className='fad fa-image f-20 mx-2'></i>
        <span className=''>{title ?? 'نمایش تصویر'}</span>
      </div>
      <div className='d-flex flex-column justify-content-center align-items-center my-4'>
        <img src={image} style={{ maxWidth: '100%' }} alt='' />
      </div>

      <div className='d-flex flex-row justify-content-around my-3'>
        <button
          onClick={() => setModalIsOpen(false)}
          className='btn btn-danger w-48 f-13'
        >
          بستن
        </button>
      </div>
    </Modal>
  );
};

export default ShowImageModal;
